import { render } from "./Highlight.vue?vue&type=template&id=5762a8a9&scoped=true"
import script from "./Highlight.vue?vue&type=script&lang=js"
export * from "./Highlight.vue?vue&type=script&lang=js"

import "./Highlight.vue?vue&type=style&index=0&id=5762a8a9&scoped=true&lang=css"

import exportComponent from "/opt/build/repo/node_modules/@vue/cli-service/node_modules/vue-loader-v16/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-5762a8a9"]])

export default __exports__